module.exports = __webpack_public_path__ + "static/media/test_basic_loading.46ad69fe.csv";